exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._37YFp{margin-bottom:30px}._1vNBQ{-webkit-box-shadow:0 2px 4px rgba(0,0,0,.1);box-shadow:0 2px 4px rgba(0,0,0,.1);background-color:#fff}.eWz9L{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:15px}._2Z5vn{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._3DyGz{font-weight:600;font-size:20px;line-height:120%;padding:20px 15px 0;margin:0}", ""]);

// exports
exports.locals = {
	"root": "_37YFp",
	"card": "_1vNBQ",
	"flexContainer": "eWz9L",
	"column": "_2Z5vn",
	"subHeadline": "_3DyGz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/BrandsList/BrandsList.css
// module id = 2906
// module chunks = 33